class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.atc = document.querySelector(this.dataset.mainAtc);
    if (!this.atc) return;

    this.bottomGap = 20; // matches CSS bottom: 2rem

    // Toggle visibility on scroll
    const toggle = () => {
      const isVisible = this.atc.getBoundingClientRect().bottom < 0;
      this.classList.toggle('is-visible', isVisible);
      this.syncPageOffset(isVisible);
    };
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', () => this.syncPageOffset(this.classList.contains('is-visible')), {
      passive: true,
    });
    toggle();

    // Click dots -> update main selector
    this.querySelectorAll('.js-sticky-atc__variant-item').forEach((dot) => {
      dot.onclick = () => {
        const match = document.querySelector(
          `custom-variant-selector [value="${CSS.escape(String(dot.dataset.productId))}"]`,
        );
        if (!match) return;
        if (match.tagName === 'INPUT') {
          match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const select = match.tagName === 'OPTION' ? match.closest('select') : match;
          if (select && select.tagName === 'SELECT') {
            select.value = dot.dataset.productId;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
    });

    // Main selector changed -> update sticky UI
    document.addEventListener('custom-variant-changed', ({ detail }) => {
      this.querySelectorAll('.js-sticky-atc__variant-item').forEach((d) =>
        d.classList.toggle('is-active', d.dataset.productId === detail.productId),
      );
      this.querySelectorAll('.js-price').forEach((p) => (p.textContent = detail.price.replace(/\s+/g, '')));
      const idInput = this.atc.closest('form')?.querySelector('[name="id"]');
      if (idInput) idInput.value = detail.variantId;
      if (this.classList.contains('is-visible')) this.syncPageOffset(true);
    });

    // Submit main ATC
    this.querySelector('.js-sticky-atc__button').onclick = () => this.atc.click();
  }

  syncPageOffset(isVisible) {
    if (isVisible) {
      const offset = Math.ceil(this.getBoundingClientRect().height) + this.bottomGap;
      document.documentElement.style.setProperty('--sticky-atc-page-offset', `${offset}px`);
      document.body.classList.add('has-sticky-atc-offset');
    } else {
      document.documentElement.style.removeProperty('--sticky-atc-page-offset');
      document.body.classList.remove('has-sticky-atc-offset');
    }
  }
}
customElements.define('sticky-add-to-cart', StickyAddToCart);
